import { FC, } from 'react';
// 组件
import InternalCardTable from './cardTable';
import Options from './subpage/options';
import Operation from './subpage/operation';
// 常量
import type { CardTableProps, OptionsProps, OperationPorps, OptionItem, OptionItemProps, OperationItem, } from './interface';
import './style.less';

export type { CardTableProps, OptionsProps, OperationPorps, OptionItem, OptionItemProps, OperationItem, };

type ICardTableComponent = FC<CardTableProps> & {
  /** 列显示 */
  Options: FC<OptionsProps>;
  /** 操作按钮 */
  Operation: FC<OperationPorps>;
};

/** 看板列表 */
const CardTable = InternalCardTable as ICardTableComponent;
CardTable.Options = Options;
CardTable.Operation = Operation;

export default CardTable;
